/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Workout_Readiness_High_StressInputs */

const en_us2_workout_readiness_high_stress = /** @type {(inputs: Workout_Readiness_High_StressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`High stress: ${i?.pct}% fewer sets today`)
};

const pt_br2_workout_readiness_high_stress = /** @type {(inputs: Workout_Readiness_High_StressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estresse alto: ${i?.pct}% menos séries hoje`)
};

const es_419_workout_readiness_high_stress = /** @type {(inputs: Workout_Readiness_High_StressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estrés alto: ${i?.pct}% menos series hoy`)
};

const pt_pt2_workout_readiness_high_stress = /** @type {(inputs: Workout_Readiness_High_StressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stress alto: menos ${i?.pct}% de séries hoje`)
};

const fr_fr2_workout_readiness_high_stress = /** @type {(inputs: Workout_Readiness_High_StressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stress élevé : ${i?.pct} % de séries en moins aujourd'hui`)
};

const de_de2_workout_readiness_high_stress = /** @type {(inputs: Workout_Readiness_High_StressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Viel Stress: heute ${i?.pct}% weniger Sätze`)
};

const it_it2_workout_readiness_high_stress = /** @type {(inputs: Workout_Readiness_High_StressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stress alto: ${i?.pct}% di serie in meno oggi`)
};

/**
* | output |
* | --- |
* | "High stress: {pct}% fewer sets today" |
*
* @param {Workout_Readiness_High_StressInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_readiness_high_stress = /** @type {((inputs: Workout_Readiness_High_StressInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Readiness_High_StressInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_readiness_high_stress(inputs)
	if (locale === "es-419") return es_419_workout_readiness_high_stress(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_readiness_high_stress(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_readiness_high_stress(inputs)
	if (locale === "de-DE") return de_de2_workout_readiness_high_stress(inputs)
	if (locale === "it-IT") return it_it2_workout_readiness_high_stress(inputs)
	return en_us2_workout_readiness_high_stress(inputs)
});
export { workout_readiness_high_stress as "workout.readiness_high_stress" }